import { NavigationGuard } from 'vue-router';
import {
  trackRouteChange,
  trackMemorySnapshot,
  trackFpsForDuration
} from '@/common/telemetry';

const PAGE_TRANSITION_FPS_DURATION_MS = 2000;

export default (function telemetryRouteHandler(to, from) {
  if (from.name) {
    trackRouteChange(to, from);
    trackMemorySnapshot({
      route_name: to.name,
      prev_route_name: from.name,
      route_path: to.path,
      trigger: 'route_change'
    });

    trackFpsForDuration(
      `page-transition-${from.name}-to-${to.name}`,
      PAGE_TRANSITION_FPS_DURATION_MS,
      {
        event_type: 'page_transition',
        from_route: from.name,
        to_route: to.name,
        from_path: from.path,
        to_path: to.path,
        trigger: 'route_change'
      }
    );
  }
}) as NavigationGuard;
